"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetChildInfoAllOfApiKeysV2 {
    static getAttributeTypeMap() {
        return GetChildInfoAllOfApiKeysV2.attributeTypeMap;
    }
}
GetChildInfoAllOfApiKeysV2.discriminator = undefined;
GetChildInfoAllOfApiKeysV2.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "key",
        "baseName": "key",
        "type": "string"
    }
];
exports.GetChildInfoAllOfApiKeysV2 = GetChildInfoAllOfApiKeysV2;
//# sourceMappingURL=getChildInfoAllOfApiKeysV2.js.map